import * as React from 'react'
import { DomainSendIntegrationModel } from '@halo/models/send-integration-configurations/domain-send-integration.model'
import { DomainDto } from '@halo/dtos/domain.dto'
import { DomainService } from '@halo/services/index'
import { Container } from 'typescript-ioc'
import { SendIntegrationsContext } from './send-integrations-context'
import { ApnsSendIntegrationsWell } from './apns-send-integrations-well'
import { FcmSendIntegrationsWell } from './fcm-send-integrations-well'

interface ISendIntegrationsEditor {
    loading?: boolean
    integrations: DomainSendIntegrationModel
    domain: DomainDto
    onChange?: (value: DomainSendIntegrationModel) => any
    className?: string
}

interface ISendIntegrationsEditorState {}

let CHANGE_DEBOUNCE_TIMEOUT: any

export class SendIntegrationsEditor extends React.Component<ISendIntegrationsEditor, ISendIntegrationsEditorState> {
    protected domainSvc: DomainService

    public constructor(props: ISendIntegrationsEditor) {
        super(props)

        this.domainSvc = Container.get(DomainService)
    }

    public render() {
        const { domain, integrations: _integrations, loading } = this.props

        const integrations = _integrations.clone()

        return (
            <SendIntegrationsContext.Provider
                value={{
                    loading: loading ?? false,
                    domain,
                    setSendIntegrations: this.emitChange,
                    sendIntegrations: integrations,
                }}
            >
                <ApnsSendIntegrationsWell className={this.props.className} integrations={integrations} />
                <FcmSendIntegrationsWell className={this.props.className} integrations={integrations} />
            </SendIntegrationsContext.Provider>
        )
    }

    protected emitChange = async (changes: DomainSendIntegrationModel, debounce: boolean = false) => {
        clearTimeout(CHANGE_DEBOUNCE_TIMEOUT)
        CHANGE_DEBOUNCE_TIMEOUT = setTimeout(
            () => {
                this.props.onChange?.(changes)
            },
            debounce ? 320 : 0,
        )
    }
}
